import React, { useEffect } from "react";
import Stage from "../../../../components/Stage";

const ThankYou = () => {
    const [namePage, setNamePage] = React.useState("");
    const [pathImage, setPathImage] = React.useState("");

    useEffect(() => {
        const path = window.location.pathname;
        const pathName = path.split("/")[2];
        const capitalizedPathName = pathName.charAt(0).toUpperCase() + pathName.slice(1);

        if (capitalizedPathName === "Accesorios") {
            setPathImage(process.env.REACT_APP_RESOURCES_IMAGES_PATH + "formsSalesforce/form_accesorios-collection_header.jpg");
        } else {
            setPathImage(process.env.REACT_APP_RESOURCES_IMAGES_PATH + "formsSalesforce/banner_form_audi_collection_gracias.jpg");
        }
        setNamePage(capitalizedPathName);

        document.title = capitalizedPathName + " - Gracias";
    }, []);

    return (
        <>
            <div className="">
                <Stage title="Solicitud de información" img={pathImage} positionTitle="bottom" />
                <section className="container mt-5 pt-5 pb-5">
                    <div className="row pt-5">
                        <div className="col-12">
                            <h1 className="text-center">Gracias por contactarnos</h1>
                            <p className="text-center mt-5 pt-4 mb-5">Estamos procesando tu solicitud. Un asesor de nuestro equipo se pondrá en contacto contigo a la brevedad.</p>
                            <div className="d-flex justify-content-center mb-5 pb-5">
                                <a className='button-home mt-5 mb-5' href={namePage === "Accesorios" ? process.env.REACT_APP_URL_HOME_ACCESORIOS : process.env.REACT_APP_URL_HOME_COLLECTION} target="_parent">
                                    Volver al Home
                                </a>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default ThankYou;